export enum RecipeType {
    SingleVision = 0,
    Bifocal = 1
}